<template>
  <TabbedBox>
    <template v-slot:tablist>
      <Tab :first="true" tabid="tab-agents">
        <i class="far fa-sparkles"></i> Agents
      </Tab>
    </template>
    <template v-slot:tabcontent>
      <TabPage :first="true" tabid="tab-agents">
        <div class="row">
          <div class="col-lg-12">
            <ContentTitle>AI Agents</ContentTitle>
            <ContentSubTitle>List of AI Agents available</ContentSubTitle>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <StaticDataTable class="static-table-list" >
              <template v-slot:header>
                <tr>
                  <th>Agent</th>
                  <th>Title</th>
                  <th>Department</th>
                  <th>Actions</th>
                </tr>
              </template>
              <template v-slot:body>
                <tr v-for="agent in agentList" :key="agent.id">
                  <td class="font-weight-bold">{{agent.name}}</td>
                  <td>{{agent.title}}</td>
                  <td>{{agent.department}}</td>
                  
                  <td>
                    <ActionDropMenu v-if="userHasUpdatePermission(PermissionTypes.AIPermissionTypes.aiConfig)" :tableAction="true" :forceDropdown="true">
                      <DropdownMenuItem @click="editAgent(agent)" icon="fa-pencil">Edit Agent</DropdownMenuItem>
                    </ActionDropMenu>
                  </td>
                </tr>
              </template>
            </StaticDataTable>
          </div>
        </div>
      </TabPage>
    </template>
  </TabbedBox>
</template>


<script>
import AIAgentDialog from '@/modules/ai/views/aiAgentDialog'

export default {
  name: 'AIConfiguration',
  data() {
    return {
      agentList: []
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.pageLoadData(this.$apiService.aiService.getAgentList())
      .then(response => {
        this.agentList = response.data.filter(agent => agent.isActive)
      })
      .catch(err => this.handlePageLoadError(err))
    },
    reloadData() {
      this.requestData()
    },
    editAgent(agent) {
      
      this.displayModal(AIAgentDialog, { 
        id: agent.id
      })
      .then((success) => {
        if(success) {
          this.successToast('Agent Updated')          
          this.reloadData()
        }
      })

    }
  }
}
</script>